import { render, staticRenderFns } from "./PredictionForm.vue?vue&type=template&id=cf9a9d5c&"
import script from "./PredictionForm.vue?vue&type=script&lang=js&"
export * from "./PredictionForm.vue?vue&type=script&lang=js&"
import style0 from "./PredictionForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports